import { render, staticRenderFns } from "./GrahamsLawSIM.vue?vue&type=template&id=573c9089&"
import script from "./GrahamsLawSIM.vue?vue&type=script&lang=ts&"
export * from "./GrahamsLawSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports